import type { TypeToken } from "@codemation/core";
import type { SignedRunEventRelayPublisher } from "@codemation/eventbus-redis";

export const SignedRunEventRelayPublisherToken = Symbol.for(
  "codemation.pairing.SignedRunEventRelayPublisher",
) as TypeToken<SignedRunEventRelayPublisher>;
